var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAvtar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 60,
    viewBox: "0 0 60 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.587821,
    d: "M30.0001 26.4444C26.5636 26.4444 23.7778 23.6587 23.7778 20.2222C23.7778 16.7858 26.5636 14 30.0001 14C33.4365 14 36.2223 16.7858 36.2223 20.2222C36.2223 23.6587 33.4365 26.4444 30.0001 26.4444Z",
    fill: "#0074B2"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.001 40.7543C16.604 33.3301 22.6296 29.5555 29.9741 29.5555C37.4219 29.5555 43.5409 33.1227 43.9968 40.7555C44.0149 41.0596 43.9968 42 42.8282 42C37.064 42 28.4985 42 17.1317 42C16.7416 42 15.9682 41.1587 16.001 40.7543Z",
    fill: "#0074B2"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAvtar);
export default __webpack_public_path__ + "static/media/avtar.a9730719dfa29dec47aeeda56d0da009.svg";
export { ForwardRef as ReactComponent };